import type { Template } from '@/types/template';

/**
 * Mock templates data for the GraphQL templates list in demo mode.
 *
 * This list backs the admin templates screen, which deliberately shows both a shared group-level
 * template and the current company's override of it. The pickers use `demo-data/templates.ts`
 * instead, where the parent is shadowed by its override — mirroring the live queries.
 */
export const mockTemplates: Template[] = [
  {
    id: '1',
    name: 'Payment Reminder',
    type: 'email',
    subject: 'Payment Reminder - Account <<accountNumber>>',
    content: '',
    isDefault: true,
    category: ['payment', 'reminder'],
    variables: [],
    lastModified: '2024-01-15T10:00:00Z',
    createdAt: '2024-01-01T10:00:00Z',
    createdBy: 'Admin User',
  },
  {
    id: '2',
    name: 'Welcome Email',
    type: 'email',
    subject: 'Welcome to <<companyName>>',
    content: '',
    isDefault: false,
    category: ['welcome', 'onboarding'],
    variables: [],
    lastModified: '2024-01-20T14:30:00Z',
    createdAt: '2024-01-10T09:00:00Z',
    createdBy: 'Admin User',
  },
  {
    id: '3',
    name: 'Monthly Statement',
    type: 'statement',
    content: '',
    isDefault: true,
    category: ['monthly', 'statement'],
    variables: [],
    lastModified: '2024-01-18T11:00:00Z',
    createdAt: '2024-01-05T10:00:00Z',
    createdBy: 'Admin User',
  },
  {
    id: '4',
    name: 'Overdue Notice',
    type: 'email',
    subject: 'Overdue Payment Notice',
    content: '',
    isDefault: false,
    category: ['overdue', 'collections'],
    variables: [],
    lastModified: '2024-01-25T09:30:00Z',
    createdAt: '2024-01-12T10:00:00Z',
    createdBy: 'Admin User',
  },
  {
    id: '6',
    name: 'Payment Confirmation',
    type: 'email',
    subject: 'Payment Received - Thank You',
    content: '',
    isDefault: false,
    category: ['payment', 'confirmation'],
    variables: [],
    lastModified: '2024-01-28T13:00:00Z',
    createdAt: '2024-01-15T10:00:00Z',
    createdBy: 'Admin User',
  },
  {
    id: '7',
    name: 'Final Notice',
    type: 'email',
    subject: 'FINAL NOTICE - Immediate Action Required',
    content: '',
    isDefault: false,
    category: ['final', 'collections', 'urgent'],
    variables: [],
    lastModified: '2024-01-30T16:00:00Z',
    createdAt: '2024-01-30T16:00:00Z',
    createdBy: 'Admin User',
  },
  {
    // Company override of 'Payment Reminder', whose shared parent has since been edited.
    id: '8',
    name: 'Payment Reminder',
    isCompanyOverride: true,
    sourceTemplateId: '1',
    hasParentChangedSinceOverride: true,
    type: 'email',
    subject: 'Payment Reminder - Account <<accountNumber>>',
    content: '',
    isDefault: false,
    category: ['payment', 'reminder'],
    variables: [],
    lastModified: '2024-01-12T09:00:00Z',
    createdAt: '2024-01-12T09:00:00Z',
    createdBy: 'Admin User',
  },
  {
    // Company override with no drift: its parent has not changed since.
    id: '9',
    name: 'Final Notice',
    isCompanyOverride: true,
    sourceTemplateId: '7',
    type: 'email',
    subject: 'FINAL NOTICE - Immediate Action Required',
    content: '',
    isDefault: false,
    category: ['final', 'collections', 'urgent'],
    variables: [],
    lastModified: '2024-02-02T10:00:00Z',
    createdAt: '2024-02-02T10:00:00Z',
    createdBy: 'Admin User',
  },
];
